import React from "react";
import { useLocation } from "wouter";

import { RedirectToProps } from "./types";

export const RedirectTo: React.FC<RedirectToProps> = ({ to }) => {
  const [, navigate] = useLocation();

  React.useLayoutEffect(() => {
    navigate(to, { replace: true });
  }, [navigate, to]);

  return null;
};
